import React from 'react'
import { usePathname } from 'router'
import { usePrices } from 'modules/subscription'
import { useCookieCoupon } from 'modules/coupon'

import { Meta } from 'components/dataDisplay'

import messages from './messages'


const GlobalMeta: React.FunctionComponent = () => {
  const pathname = usePathname()

  // we actually need price only for bots and non-subscribed users
  const { couponCode } = useCookieCoupon()
  const { formattedPrice: price = '' } = usePrices({
    couponCode,
  })

  const title = { ...messages.title, values: { price } }
  const description = { ...messages.description, values: { price } }

  return (
    <Meta
      title={title}
      metaDescription={description}
      image="https://cdn.scentbird.com/og/cover.png"
      pathname={pathname}
      withoutTitleTemplate
    />
  )
}


export default GlobalMeta
